<template>
  <div class="text-block impact-module">
    <div class="inner">
      <div
        v-if="data.has_border"
        class="border"
      ></div>
      
      <div 
        class="text-content" 
        v-html="data.text_content"
      ></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TextBlock',
  props: {
    data: Object
  }
}
</script>

<style scoped>
  .text-block {
    padding: 0 2rem;
  }

  .inner {
    /* border-top: 1px dashed white; */
    /* padding: 10rem 0; */
  }

  .text-content {
    font: var(--serif-small);
    max-width: 1200px;
    margin: 0 auto;
  }
</style>